import React from 'react';
import PropTypes from 'prop-types';
import FinishedCornersEdgesOptionGroup from './FinishedCornersEdges';
import ChooseCutoutsOptionGroup from './ChooseCutouts';
import ChooseInteriorAnglesOptionGroup from './ChooseInteriorAngles';
import ChooseExteriorAnglesOptionGroup from './ChooseExteriorAngles';
import ChooseASurfaceOptionGroup from './ChooseASurface';
import ChoosePlumbingOptionOptionGroup from './ChoosePlumbingOption';
import ChooseSinksOptionGroup from './ChooseSinks';
import CountertopRemovalOptionGroup from './CountertopRemovalOptions';
import ZipCodeProjectLocationOptionGroup from './ZipCodeProjectLocation';
import SurfaceMaterialOptionGroup from './SurfaceMaterial';

const UngroupedOptionGroup = ({ children }) => children.length > 0 && <div>{children}</div>;

UngroupedOptionGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default [
  { name: 'Default', template: UngroupedOptionGroup },
  { name: 'FinishedCornersEdges', template: FinishedCornersEdgesOptionGroup },
  { name: 'ChooseCutouts', template: ChooseCutoutsOptionGroup },
  { name: 'ChooseInteriorAngles', template: ChooseInteriorAnglesOptionGroup },
  { name: 'ChooseExteriorAngles', template: ChooseExteriorAnglesOptionGroup },
  { name: 'ChoosePlumbingOption', template: ChoosePlumbingOptionOptionGroup },
  { name: 'EdgeStyle', template: UngroupedOptionGroup },
  { name: 'ChooseSinks', template: ChooseSinksOptionGroup },
  { name: 'ChooseASurface', template: ChooseASurfaceOptionGroup },
  { name: 'CountertopRemoval', template: CountertopRemovalOptionGroup },
  { name: 'ZipCodeProjectLocation', template: ZipCodeProjectLocationOptionGroup },
  { name: 'CountertopSurfaceMaterial', template: SurfaceMaterialOptionGroup },
];
